import React from "react";
import { RCCCalendar } from "react-common-components";
import { IComponentCalendar } from "react-common-components/dist/components/Calendar/interface";
import { useTranslation } from "src/context/Translations/context";
import { css } from "styled-components";

const ScoreCalendar: React.FC<IComponentCalendar> = ({...props}) => {
	const { translate,currentLanguage} = useTranslation();
    
	const defaultMessages =  {
		date: translate("Data"),
		time: translate("Tempo"),
		event: translate("Eventos"),
		allDay: translate("Dia todo"),
		week: translate("Semana"),
		work_week: translate("Dias úteis"),
		day: translate("Dia"),
		month: translate("Mês"),
		previous: translate("Anterior"),
		next: translate("Proximo"),
		yesterday: translate("Ontem"),
		tomorrow: translate("Amanhã"),
		today: translate("Hoje"),
		agenda: translate("Lista"),
		noEventsInRange: `${translate("Não há eventos nesse periodos")}.`,
		showMore: (total:number) => translate("Mostrar +{{total}}",{total})
	};
	return ( 
		
		<RCCCalendar
			culture={currentLanguage}
			messages={defaultMessages}
			styleInline={css`
				margin-top:1rem;
				height:unset;
				min-height:800px;

				.rbc-row-content{
					min-height:145px;
				}
				
				.rbc-month-row{
					overflow: unset;
				}
				
				.rbc-show-more{
					font-size: 0.75rem;
				}

				.rbc-event, .rbc-day-slot .rbc-background-event{
					background-color:var(--purple);
				}
				
				.rbc-toolbar button{
					padding: 0.275rem 0.5rem;
					font-size: 0.85rem;
				}

				.rbc-toolbar button:hover, .rbc-toolbar button:focus{
					color:"#474555"
				}

				.rbc-agenda-view table.rbc-agenda-table tbody > tr > td.rbc-agenda-event-cell{
					padding:5px 5px;
				}

			`}	
			{...props}
		/> 
	);

};

export default ScoreCalendar;
